import React, { useState } from 'react'
import glamorous from 'glamorous'
import { BodyText, HeadingText } from '@paypalcorp/pp-react'

import HandleMoreInfoLink from '../details/handle-more-info-link'
import HandleInput from '../details/input-container'
import { showServiceError } from './util'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/error')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start', // 'center',
  marginTop: '48px',
})

const GenericInputContainerPadding = glamorous.div({
  margin: '24px 0',
  width: '100%',
})

const HeadingContainer = glamorous.div({
  margin: '12px 0',
})

const SubHeaderContainer = glamorous.div({
  marginTop: 0,
  marginBottom: 32,
})

const ButtonContainer = glamorous.div({
  display: 'flex',
  margin: 'auto',
})

const ContinueButton = glamorous.button({
  margin: 'auto',
  width: '310px',
  '@media(max-width: 414px)': {
    width: '290px',
  },
})

const ErrorCreateHandle = (props) => {
  const {
    sellerProfileState: {
      state: { businessHandle, isValidBusinessHandle } = {},
    } = {},
  } = props

  const [takenHandle, setTakenHandle] = useState(businessHandle)

  const [inputs, setInputs] = useState({
    businessHandle: '',
  })

  const handleChangeInput = (e) => {
    const updates = {
      ...inputs,
      [e.target.name]: e.target.value,
    }
    setInputs(updates)
    props.sellerProfileState.updateBusinessDetails(updates)
  }

  const revealNextCTA = () => {
    return inputs.businessHandle !== '' && isValidBusinessHandle
  }

  const createSellerProfile = () => {
    props.sellerProfileState.createSellerProfile(onSuccessCreate, onErrorCreate)
  }

  const onSuccessCreate = () => {
    props.history.replace('/seller/success')
  }

  const onErrorCreate = (e) => {
    setTakenHandle(inputs.businessHandle)
    const updates = {
      ...inputs,
      businessHandle: '',
      isValidBusinessHandle: false,
    }
    setInputs(updates)
    props.sellerProfileState.updateBusinessDetails(updates)
    showServiceError(e, props.history)
  }

  return (
    <Container>
      <HeadingContainer>
        <HeadingText size="md" role="heading" aria-level="1">
          {l10n('create.handle.header', { handle: takenHandle })}
        </HeadingText>
      </HeadingContainer>
      <SubHeaderContainer>
        <BodyText size="md">{l10n('create.handle.subHeader')}</BodyText>
      </SubHeaderContainer>
      <HandleMoreInfoLink />

      <GenericInputContainerPadding>
        <HandleInput
          sellerProfileState={props.sellerProfileState}
          inputValue={inputs.businessHandle}
          selectedValue={inputs.businessHandle}
          updateBusinessHandle={handleChangeInput}
        />
      </GenericInputContainerPadding>
      {revealNextCTA() && (
        <ButtonContainer>
          <ContinueButton
            className="vx_btn"
            label="Next"
            onClick={createSellerProfile}
          >
            {l10n('create.handle.continue')}
          </ContinueButton>
        </ButtonContainer>
      )}
    </Container>
  )
}

export default ErrorCreateHandle
